const TestimonialsSection = () => {
  const testimonials = [
    {
      name: 'María González',
      location: 'Centre, El Prat',
      rating: 5,
      text: 'Excelente servicio de vaciado de piso. Muy profesionales y discretos. Dejaron todo impecable en tiempo récord. Totalmente recomendable para cualquier vaciado en El Prat.',
      avatar: 'MG',
      color: 'bg-blue-100 text-blue-600',
    },
    {
      name: 'Carlos Martínez',
      location: 'Viladecans',
      rating: 5,
      text: 'Contraté sus servicios para vaciar un local comercial. El equipo fue muy eficiente y el precio muy competitivo. Sin duda los volvería a contratar.',
      avatar: 'CM',
      color: 'bg-green-100 text-green-600',
    },
    {
      name: 'Ana Rodríguez',
      location: 'Sant Cosme, El Prat',
      rating: 5,
      text: 'Necesitaba ayuda con un caso de síndrome de Diógenes en la vivienda de un familiar. El trato fue excepcional, muy respetuosos y discretos. Gracias por todo.',
      avatar: 'AR',
      color: 'bg-purple-100 text-purple-600',
    },
    {
      name: 'Inmobiliaria Gavà',
      location: 'Gavà',
      rating: 5,
      text: 'Trabajamos con ellos regularmente para el vaciado de pisos. Siempre cumplen los plazos y dejan las viviendas perfectas para entregar. Muy profesionales.',
      avatar: 'IG',
      color: 'bg-orange-100 text-orange-600',
    },
    {
      name: 'Pedro Sánchez',
      location: 'Cornellà',
      rating: 5,
      text: 'Servicio rápido y eficiente. Vaciaron mi piso en un día y se encargaron de todo, incluida la limpieza final. Precio justo y trato excelente.',
      avatar: 'PS',
      color: 'bg-pink-100 text-pink-600',
    },
    {
      name: 'Laura Fernández',
      location: 'L\'Hospitalet',
      rating: 5,
      text: 'Contraté el servicio completo: vaciado, limpieza y pintura. El resultado fue perfecto. Muy contentos con el trabajo realizado. Los recomiendo 100%.',
      avatar: 'LF',
      color: 'bg-indigo-100 text-indigo-600',
    },
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-dark mb-4">
            Lo que dicen nuestros clientes
          </h2>
          <p className="text-lg text-secondary max-w-3xl mx-auto">
            Más de 500 clientes satisfechos con nuestros servicios de <strong>vaciado de pisos</strong> y <strong>limpieza extrema</strong> en El Prat de Llobregat
          </p>
        </div>

        {/* Testimonials Grid - Masonry Style */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className="bg-white border border-secondary/20 rounded-xl p-6 hover:shadow-lg hover:-translate-y-1 transition-all duration-300"
            >
              {/* Header */}
              <div className="flex items-center gap-4 mb-4">
                {/* Avatar */}
                <div className={`w-12 h-12 rounded-full flex items-center justify-center font-bold text-lg ${testimonial.color}`}>
                  {testimonial.avatar}
                </div>

                {/* Name and Location */}
                <div className="flex-1">
                  <h4 className="font-bold text-dark">{testimonial.name}</h4>
                  <p className="text-sm text-secondary">{testimonial.location}</p>
                </div>
              </div>

              {/* Testimonial Text */}
              <p className="text-dark/80 leading-relaxed mb-4 italic">
                "{testimonial.text}"
              </p>

              {/* Rating */}
              <div className="flex gap-1">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-yellow-400 text-lg"></i>
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* Trust Badge */}
        <div className="mt-12 text-center">
          <div className="inline-flex items-center gap-3 bg-light px-8 py-4 rounded-full">
            <i className="ri-shield-check-fill text-3xl text-primary"></i>
            <div className="text-left">
              <div className="font-bold text-dark">Garantía de satisfacción</div>
              <div className="text-sm text-secondary">4.9/5 estrellas · 127 reseñas verificadas</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
